

module.exports = function($) {

    return {
        init: init
    };

    function init() {
        toggleAccordion();
    }

    function toggleAccordion() {
        var accordion = $('[data-toggle-accordion]');
        var accordionLinks = $('a', accordion);

        accordion.on('click', function() {
            var $this = $(this);

            $this
                .siblings()
                .removeClass('active')
                .children('.accordion__content')
                .slideUp();

            $this
                .stop()
                .toggleClass('active')
                .children('.accordion__content')
                .slideToggle();
        });

        accordionLinks.on('click', function(event) {
            event.stopPropagation();
        });
    }
};
